import {
  AD_SLOT_CARTINTERMIDIATE,
  AD_SLOT_CATEGORY_SMALL_1,
  AD_SLOT_CATEGORY_SMALL_2,
  AD_SLOT_CATEGORY_WIDE,
  AD_SLOT_CONFIRMATION,
  AD_SLOT_GLOBAL_TOP,
  AD_SLOT_HOMEPAGE_SERVICES_BANNER,
  AD_SLOT_HOMEPAGE_SMALL_1,
  AD_SLOT_HOMEPAGE_SMALL_2,
  AD_SLOT_HOMEPAGE_SMART,
  AD_SLOT_HOMEPAGE_WIDE,
  AD_SLOT_PDP_CROSSSELL,
  AD_SLOT_PDP_RX,
  AD_SLOT_SEARCH_BRAND_TOP,
  AD_SLOT_SEARCH_CATEGORY_TOP,
  AD_SLOT_SEARCH_HITS_1,
  AD_SLOT_SEARCH_HITS_2,
} from 'views/consts/adSlots'

export const SIZES_BY_ID = {
  // layout (each page): top
  [AD_SLOT_GLOBAL_TOP]: {
    large: { width: 0, height: 0 },
    small: { width: 0, height: 0 },
  },

  // home page: CategoryWide CMS component
  [AD_SLOT_HOMEPAGE_WIDE]: {
    large: { width: 980, height: 300 },
    small: { width: 347, height: 135 },
  },

  // home page: Services Widget Banner
  [AD_SLOT_HOMEPAGE_SERVICES_BANNER]: {
    small: { width: 347, height: 137 },
    large: { width: 480, height: 187 },
  },
  // home page: CategorySmall CMS component (first)
  [AD_SLOT_HOMEPAGE_SMALL_1]: {
    large: { width: 480, height: 200 },
    small: { width: 347, height: 137 },
  },
  // home page: CategorySmall CMS component (second)
  [AD_SLOT_HOMEPAGE_SMALL_2]: {
    large: { width: 480, height: 200 },
    small: { width: 347, height: 137 },
  },
  // home page: EyecatcherSmart CMS component
  [AD_SLOT_HOMEPAGE_SMART]: {
    large: { width: 480, height: 460 },
    small: { width: 347, height: 135 },
  },

  // category page: CategoryWide CMS component
  [AD_SLOT_CATEGORY_WIDE]: {
    large: { width: 728, height: 220 },
    small: { width: 347, height: 135 },
  },
  // category page: CategorySall CMS component (first)
  [AD_SLOT_CATEGORY_SMALL_1]: {
    large: { width: 354, height: 150 },
    small: { width: 347, height: 135 },
  },
  // category page: CategorySall CMS component (second)
  [AD_SLOT_CATEGORY_SMALL_2]: {
    large: { width: 354, height: 150 },
    small: { width: 347, height: 135 },
  },

  // search page (brand product listing): top
  [AD_SLOT_SEARCH_BRAND_TOP]: {
    large: { width: 0, height: 0 },
    small: { width: 0, height: 0 },
  },
  // search page (category product listing): top
  [AD_SLOT_SEARCH_CATEGORY_TOP]: {
    large: { width: 0, height: 0 },
    small: { width: 0, height: 0 },
  },
  // search page: between search results (first)
  [AD_SLOT_SEARCH_HITS_1]: {
    // banner is not shown in most search results so we are not using placeholders at all
    large: { width: 0, height: 0 },
    small: { width: 0, height: 0 },
  },
  // search page: between search results (second)
  [AD_SLOT_SEARCH_HITS_2]: {
    large: { width: 0, height: 0 },
    small: { width: 0, height: 0 },
  },
  // product page: cross-sell widget
  [AD_SLOT_PDP_CROSSSELL]: {
    large: { width: 480, height: 200 },
    small: { width: 0, height: 0 },
  },
  // product page: RX message
  [AD_SLOT_PDP_RX]: {
    large: { width: 0, height: 0 },
    small: { width: 0, height: 0 },
  },
  // order confirmation page
  [AD_SLOT_CONFIRMATION]: {
    large: { width: 0, height: 0 },
    small: { width: 0, height: 0 },
  },
  // cart intermidiate page
  [AD_SLOT_CARTINTERMIDIATE]: {
    large: { width: 357, height: 150 },
    small: { width: 0, height: 0 },
  },
}
